import React from 'react';
import { useTranslation } from 'react-i18next';
import PostLandingShell from '../components/PostLandingShell';
import '../pages/PostLoginWelcome.css';
import LanguageSwitch from '../components/LanguageSwitch';

export default function ExistingUserWelcome() {
  const { t } = useTranslation();

  const listItems = [
    t('welcomePage.next1'),
    t('welcomePage.next2'),
    t('welcomePage.next3'),
    t('welcomePage.next4'),
  ];

  return (
    <PostLandingShell
      pageClassName="gm-pl-page--welcome"
      headerAside={<LanguageSwitch />}
      hero={
        <div className="gm-pl-hero--user-check" aria-hidden="true">
          <i className="ri-user-follow-line gm-pl-hero-mockup-icon" />
        </div>
      }
      badge={t('welcomePage.welcomeBadge')}
      title={t('welcomePage.title')}
      subtitle={<p className="gm-pl-subtitle">{t('welcomePage.body')}</p>}
      listItems={listItems}
      footnote={t('welcomePage.footnote')}
      primaryLabel={t('successPage.getStarted')}
      onPrimary={() => {
        window.location.assign('/intake');
      }}
      backLinkLabel={t('welcomePage.backLink')}
      onBackLink={() => {
        window.location.href = 'https://globalmobility.law/';
      }}
      onBrandClick={() => {
        window.location.href = 'https://globalmobility.law/';
      }}
    />
  );
}

